export default __webpack_public_path__ + "static/icon-34-6-de8b7e51efe96d1a7f203be468484a70.png";